function renderDiscountFlagByVariant(variantId) {
  const el = document.getElementById('discount-flag');
  if (!el) return;

  const variant = window.__fullProduct?.variants?.find((v) => v.id === parseInt(variantId));
  if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
    el.innerHTML = '';
    el.removeAttribute('aria-busy');
    return;
  }

  const discount = 100 - Math.ceil((variant.price * 100) / variant.compare_at_price);
  el.innerHTML = `<span class="flag typo-body-xs discount"><span class="flag__text">- ${discount}%</span></span>`;
  el.removeAttribute('aria-busy');
}

function setupDiscountFlag(fallbackId) {
  const input = document.querySelector('input[name="id"]');

  if (input?.value) {
    renderDiscountFlagByVariant(input.value);
  } else {
    const mo = new MutationObserver(() => {
      const el = document.querySelector('input[name="id"]');
      if (el?.value) {
        renderDiscountFlagByVariant(el.value);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    renderDiscountFlagByVariant(fallbackId);
  }

  document.addEventListener('variant:change', function (event) {
    renderDiscountFlagByVariant(event.detail.variant.id);
  });
}
